import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ORGANISATION_PLACEHOLDER } from '@assetaccountant/core/http-token.interceptor';
import { environment } from 'environments/environment';
import { Observable, Subscribable } from 'rxjs';

export type PaymentMethod =
  | {
      id: string;
      type: 'Card';
      card: {
        brand: 'Visa' | 'AmericanExpress' | 'MasterCard';
        fundingType: string;
        expMonth: number;
        expYear: number;
        last4: string;
      };
      isPrimary: boolean;
    }
  | {
      id: string;
      type: 'Unknown';
      card: undefined;
      isPrimary: boolean;
    };

function awaitable<T>(obs: Observable<T>) {
  return {
    subscribe(...args: any[]) {
      return obs.subscribe(...args);
    },
    then(...args: any[]) {
      return obs.toPromise().then(...args);
    },
  } as Subscribable<T> & PromiseLike<T>;
}

@Injectable({ providedIn: 'root' })
export class PaymentService {
  constructor(private http: HttpClient) {}
  // in a future PR I will come back and swap organisationId for subscriptionId but I want to see this working end to end
  // to test that stripe behaves as expected and this is the quickest route to that test
  getPaymentMethods({ organisationId }: { organisationId?: number } = {}) {
    return awaitable(
      this.http.get<PaymentMethod[]>(
        `${environment.servicesApiUrl}/api/organisation/${
          organisationId || ORGANISATION_PLACEHOLDER
        }/payment-methods`,
      ),
    );
  }

  attachPaymentMethod({
    organisationId,
    paymentMethodId,
  }: {
    organisationId?: number;
    paymentMethodId: string;
  }) {
    return awaitable(
      this.http.post<void>(
        `${environment.servicesApiUrl}/api/organisation/${
          organisationId || ORGANISATION_PLACEHOLDER
        }/attach-payment-method`,
        {
          paymentMethodId,
        },
      ),
    );
  }

  setPrimaryPaymentMethod({
    organisationId,
    paymentMethodId,
  }: {
    organisationId?: number;
    paymentMethodId: string;
  }) {
    return this.http.post<void>(
      `${environment.servicesApiUrl}/api/organisation/${
        organisationId || ORGANISATION_PLACEHOLDER
      }/payment-methods/${paymentMethodId}/set-primary`,
      {},
    );
  }
}
